import {
    format,
    parse,
    add,
    addDays,
    differenceInCalendarMonths,
    startOfToday,
    differenceInDays,
    parseISO,
    isValid,
} from "date-fns";
import {DATE_FORMATS, USED_LOCALE} from "base/config";
import TextUtil from "./TextUtil";

const toDate = date => {
    if (!date) {
        return null;
    }
    if (date instanceof Date) {
        return date;
    }
    if (typeof date === "string") {
        const parsed = parseISO(date);
        return isValid(parsed) ? parsed : null;
    }
    return null;
};

const DateUtil = {
    // Transform to UI format date DD/MM/YYYY
    formatDate(date, dateFormat = DATE_FORMATS.CLIENT_DATEFORMAT) {
        const d = toDate(date);
        if (!d) {
            return "";
        }
        return format(d, dateFormat);
    },
    formatDateForAPI(date) {
        return DateUtil.formatDate(date, DATE_FORMATS.API_DATEFORMAT);
    },
    formatDateMonth(date, dateFormat = DATE_FORMATS.CLIENT_DATEMONTHFORMAT) {
        const d = toDate(date);
        if (!d) {
            return "";
        }
        return format(d, dateFormat);
    },
    formatDateTime(date, dateFormat = DATE_FORMATS.CLIENT_DATETIMEFORMAT) {
        const d = toDate(date);
        if (!d) {
            return "";
        }
        return format(d, dateFormat);
    },
    formatDateTimeForFilenames(date) {
        return DateUtil.formatDate(date, DATE_FORMATS.FILENAME_DATETIMEFORMAT);
    },
    formatTime(date) {
        const d = toDate(date);
        if (!d) {
            return "";
        }
        return format(d, DATE_FORMATS.CLIENT_TIMEFORMAT);
    },
    formatHoursAndMinutes(millis) {
        return (
            Math.trunc(millis / 3600000) +
            " h " +
            Math.trunc((millis / 60000) % 60) +
            " min"
        );
    },
    parseDateTime(date, dateFormat = DATE_FORMATS.CLIENT_DATETIMEFORMAT) {
        return parse(date, dateFormat, new Date());
    },
    addMonths(date, months) {
        return add(date, {months});
    },
    getMonthName(month) {
        return TextUtil.capitalize(
            format(new Date(null, month - 1), "LLLL", {locale: USED_LOCALE})
        );
    },
    getMonthInDate(date) {
        return TextUtil.capitalize(
            format(new Date(date), "LLL", {locale: USED_LOCALE})
        );
    },
    getDayInDate(date) {
        return format(new Date(date), "d");
    },
    getYearInDate(date) {
        return format(new Date(date), "yyyy");
    },
    getDaysToDate(date) {
        return differenceInDays(new Date(date), startOfToday());
    },
    getDateAfterDays(date, amountOfDays) {
        return addDays(date, amountOfDays);
    },
    formatYearAndMonth(date) {
        return `${date.getMonth() + 1}/${date.getFullYear()}`;
    },
    getMonths(firstDate, lastDate) {
        return differenceInCalendarMonths(lastDate, firstDate);
    },
    getToday() {
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        return now;
    },
    getFirstDayOfCurrentMonth() {
        const today = this.getToday();
        today.setDate(1);
        return today;
    },
};

export default DateUtil;
